<template>
	<div class="basic_wrap">
		<bsHeader :title="$t('invite.invite')" @backurl="$router.back()"></bsHeader>
		<div class="user_wrap ">
			<div class="qrcode_wrap">
				<div class="qrcode">
					<img :src="data.share_code" alt="" srcset="">
				</div>
				<div class="invite_code_wrap">
					<span>{{ $t('invite.inviteCode') }}</span>
					<span class="invite_code">{{ data.invite_code }}</span>
				</div>
				<div class="invite_tips1">
					{{ $t('invite.tips1') }}
				</div>
				<div class="invite_tips2">
					{{ $t('invite.tips2') }}
				</div>
				<div class="invite_rule_btn">
					<button @click="$router.push('article/16')">{{ $t('invite.inviteRule') }}</button>
				</div>
			</div>
			<div class="link_wrap">
				<p class="tips1">{{ $t('invite.tips3') }}</p>
				<p class="tips2">{{ $t('invite.tips4') }}</p>
				<div class="invite_link">
					<div>{{ data.share_link }}</div>
					<button @click="copyData">{{ $t('invite.copy') }}</button>
				</div>
				<div class="invite_link1">

					<button @click="copyData">{{ $t('invite.copy') }}</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import bsHeader from '../../components/bsHeader.vue'
import Fetch from '../../utils/fetch'
import Clipboard from "v-clipboard";
Vue.use(Clipboard);
export default {
	name: "invite",
	components: {
		bsHeader
	},
	data() {
		return {
			data: [],
		};
	},
	created() {
		if (window.plus) {
			plus.navigator.setStatusBarBackground('#FFFFFF');
			plus.navigator.setStatusBarStyle('dark');
		}
		this.$parent.footer('user', false);
	},
	mounted() {
		this.start();
	},
	methods: {
		copyData() {
			//如果需要回调：
			this.$copyText(this.data.share_link).then(e => {
				this.$toast(this.$t('recharge.copySuccess'));
			
			}, function (e) {
				
			})
		},
		copy() {
			this.$toast(this.$t('recharge.copySuccess'));
		},
		start() {
			Fetch('/user/myTeam').then(r => {
				this.data = r.data.user_info;
			})
		}
	}
};
</script>

<style lang="less" scoped>
.basic_wrap {
	background: #ffffff;
	height: 100%;
	width: 100%;
	position: absolute;

}

.user_wrap {
	margin-top: 84px;

	.qrcode_wrap {
		text-align: center;
		color: #999;
		line-height: 2;
		font-size: 14px;
		margin-bottom: 15px;

		.qrcode {
			img {
				width: 50%;
				padding: 10px;
				background: #eaeaea;
				border-radius: 10px;
			}
		}

		.invite_code_wrap {
			.invite_code {
				color: #3775F4;
				font-weight: bold;
			}

		}

		.invite_tips1 {
			font-weight: bold;
			color: #000;
			font-size: 18px;
		}

		.invite_tips2 {}

		.invite_rule_btn {
			button {
				padding: 2px 20px;
				color: #fff;
				background: #3775F4;
				border-radius: 16px;
				margin: 5px;
			}

		}
	}

	.link_wrap {
		// background: url(../img/user/invite_bg.png) no-repeat center center;
		// background-size: 100% 100%;
		background: linear-gradient(180deg, #247EF3 0%, #89B2FF 100%);
		border-radius: 8px;
		margin: 0 24px;
		margin-left: 3%;
		color: #fff;
		padding: 24px;

		.tips1 {
			font-size: 20px;
			font-weight: bold;
			line-height: 28px;
			color: #FFFFFF;
		}

		.tips2 {
			font-size: 14px;
			line-height: 20px;
			color: #FFFFFF;
			margin-top: 6px;
		}

		.invite_link {
			line-height: 2;
			background: #fff;
			color: #000;
			padding: 10px;
			border-radius: 10px;
			position: relative;
			margin-top: 16px;

			button {
				display: none;
				position: absolute;
				right: 10px;
				bottom: 8px;
				color: #fff;
				background: #3775F4;
				border-radius: 5px;
				padding: 2px 10px;
			}
		}

		.invite_link1 {
			margin-top: 12px;

			button {

				width: 100%;
				height: 44px;
				left: 48px;
				top: 688px;

				background: #3775F4;
				border-radius: 22px;
			}
		}
	}
}
</style>
